import { FormNotifyService } from './form-notify.service';

class FormNotifyStrategyService {
  /**
   * æ¶æ¯æç¤º
   * @param formNotifyService formNotifyService
   * @param content content
   */
  public static info(formNotifyService: FormNotifyService, content: string) {
    const search = window.location.hash;
    const { odocDisableNotification = '' } = FormNotifyStrategyService.querystring(search);
    if (odocDisableNotification && odocDisableNotification.toLowerCase() === 'true') {
      return;
    }
    formNotifyService.info(content, { hideTitle: true });
  }
  /**
   * æåæç¤º
   * @param formNotifyService formNotifyService
   * @param content content
   */
  public static success(formNotifyService: FormNotifyService, content: string) {
    const search = window.location.hash;
    const { odocDisableNotification = '' } = FormNotifyStrategyService.querystring(search);
    if (odocDisableNotification && odocDisableNotification.toLowerCase() === 'true') {
      return;
    }
    formNotifyService.success(content, { hideTitle: true });
  }
  private static querystring(querystring: string): any {
    const urlSearchParams = new URLSearchParams(querystring);
    const result = {};
    urlSearchParams.forEach((value: string, key: string) => {
      result[key] = value;
    });
    return result;
  }
}
export { FormNotifyStrategyService };
